import { Image } from 'react-native';

const icons = {
  skip: Image.resolveAssetSource(require('../Assets/Images/Icons/ic_close_red@3x.png')),
  ic_refresh: Image.resolveAssetSource(require('../Assets/Images/Icons/refresh@3x.png')),
  ic_bold_small_refresh: Image.resolveAssetSource(
    require('../Assets/Images/Icons/boldSmallRefresh@3x.png'),
  ),
  ic_logo_red: Image.resolveAssetSource(require('../Assets/Images/Logo/red@3x.png')),
  ic_connected_devices: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icConnectedDevices@3x.png'),
  ),
  tray_content: Image.resolveAssetSource(require('../Assets/Images/Icons/content@3x.png')),
  ic_close_white: Image.resolveAssetSource(require('../Assets/Images/Icons/icCloseWhite@3x.png')),
  ic_small_close_white: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icSmallCloseWhite@3x.png'),
  ),
  ic_tickSolved_white: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icTickSolvedWhite@3x.png'),
  ),
  ic_WarningNotification_White: Image.resolveAssetSource(
    require('../Assets/Images/Icons/ic_warning_notification_white@3x.png'),
  ),
  ic_top_up: Image.resolveAssetSource(require('../Assets/Images/Icons/icTopUp@3x.png')),
  ic_chevron_right_red: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icChevronRightRed@3x.png'),
  ),
  ic_chevron_down: Image.resolveAssetSource(
    require('../Assets/Images/Icons/icChevronDownWhite2@3x.png'),
  ),
  ic_rewards: Image.resolveAssetSource(require('../Assets/Images/Icons/icAllRewards@3x.png')),
  icCallsContacts: Image.resolveAssetSource(require('../Assets/Images/Icons/icCallsContacts@3x.png')),
  ic_mobile: Image.resolveAssetSource(require('../Assets/Images/Icons/ic_mobile@3x.png')),
  ic_warning: Image.resolveAssetSource(require('../Assets/Images/Icons/icWarning@3x.png')),
  warning: Image.resolveAssetSource(require('../Assets/Images/Icons/warning@3x.png')),
  icPadlockClose: Image.resolveAssetSource(require('../Assets/Images/Icons/icPadlockClose@3x.png')),
  icInfoCircle: Image.resolveAssetSource(require('../Assets/Images/Icons/icInfoCircle@3x.png')),
  toolTipIndicator: Image.resolveAssetSource(require('../Assets/Images/ToolTips/group2@3x.png')),
};

const images = {
  // Background Images
  background_grey_bg_video: Image.resolveAssetSource(
    require('../Assets/Images/Background/greyBgVideo@3x.png'),
  ),
  // Vodafone Logo Images
  logo_vf_white: Image.resolveAssetSource(require('../Assets/Images/Logo/white@3x.png')),
  logo_vf_red: Image.resolveAssetSource(require('../Assets/Images/Logo/red@3x.png')),
  // Icon Images
  ic_hide_password: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icHidePassword@3x.png'),
  ),
  ic_show_password_insights: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icShowPasswordInsights@3x.png'),
  ),
  ic_WarningNotification_White: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/ic_warning_notification_white@3x.png'),
  ),
  ic_close: Image.resolveAssetSource(require('./../Assets/Images/Icons/icClose@3x.png')),
  ic_close_white: Image.resolveAssetSource(require('./../Assets/Images/Icons/icCloseWhite@3x.png')),
  ic_chevron_up_red: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/ic_chevron_up_red@3x.png'),
  ),
  ic_chevron_down_red: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/ic_chevron_down_red@3x.png'),
  ),
  ic_arrow_left: Image.resolveAssetSource(require('./../Assets/Images/Icons/icArrowLeft@3x.png')),
  ic_tick_solved: Image.resolveAssetSource(require('./../Assets/Images/Icons/ic_tick_solved@3x.png')),
  // Tobi
  tobi_default: Image.resolveAssetSource(require('./../Assets/Images/Tobi/default@3x.png')),
  // permissions
  ic_Notification: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/notification_alert@3x.png'),
  ),
  icLocation: Image.resolveAssetSource(require('./../Assets/Images/Icons/ic_location@3x.png')),
  icNetworkMap: Image.resolveAssetSource(require('./../Assets/Images/Icons/network-tower@3x.png')),
  ic_Landline_Or_Call_Minutes: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icLandlineOrCallMinutes@3x.png'),
  ),
  ic_Users_Members_Customers: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/admin@3x.png'),
  ),
  ic_pin_pad: Image.resolveAssetSource(require('./../Assets/Images/Icons/333333@3x.png')),
  ic_WarningHiLight_Theme: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icWarningHiLightTheme@3x.png'),
  ),
  ic_RefreshRed: Image.resolveAssetSource(require('./../Assets/Images/Icons/icRefreshRed@3x.png')),
  // EIO
  ic_sim: Image.resolveAssetSource(require('./../Assets/Images/Icons/icSim@3x.png')),
  ic_bills: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icBillReportGenericTariffPlan@3x.png'),
  ),
  ic_wifi_broadband: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icWifiBroadband@3x.png'),
  ),
  ic_admin: Image.resolveAssetSource(require('./../Assets/Images/Icons/icAdmin@3x.png')),
  icClock: Image.resolveAssetSource(require('./../Assets/Images/Icons/ic_clock@3x.png')),
  ic_item_badge: Image.resolveAssetSource(require('./../Assets/Images/Icons/ic_item_badge@3x.png')),
  ic_left_arrow_white: Image.resolveAssetSource(
    require('./../Assets/Images/Icons/icArrowLeftWhite@3x.png'),
  ),
  ...icons,
};
const TImages = {
  VFLogo: {
    primary: images.logo_vf_red,
    secondary: images.logo_vf_white,
  },
  ic_close: {
    primary: images.ic_close,
    secondary: images.ic_close_white,
  },
  ic_chevron_down: {
    primary: images.ic_chevron_down_red,
    secondary: images.ic_chevron_down,
  },
  ic_chevron_up: {
    primary: images.ic_chevron_up_red,
  },
  ic_tick_solved: {
    primary: images.ic_tick_solved,
    secondary: images.ic_tickSolved_white,
  },
};

export default images;
export { TImages };
